// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import FirebaseAuthHelper from "../../features/authentication/helpers/firebase-auth-helper/firebase-auth-helper";

const ProtectedRoute = ({ children }) => {
  const user = FirebaseAuthHelper.getCurrentUser();

  console.log('user :>> ', user);

  if (!user) {
    // If the user is not authenticated, redirect to the login page
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
